<mat-card class="redirect-checks-container">
  <mat-card-content>
    <div class="redirect-header">
      <mat-card-title
        ><mat-icon>compare_arrows</mat-icon>Redirect checks</mat-card-title
      >

      <button
        matButton="filled"
        color="primary"
        (click)="backToDashboard()"
        matTooltip="Back to dashboard"
      >
        <mat-icon>keyboard_backspace</mat-icon>
        Back to dashboard
      </button>
    </div>

    <div class="date-filter-controls">
      <mat-form-field appearance="fill">
        <mat-label>Calendar Start</mat-label>
        <input
          id="calendar-start"
          matInput
          [matDatepicker]="startPicker"
          [(ngModel)]="calendarStart"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="startPicker"
        ></mat-datepicker-toggle>
        <mat-datepicker #startPicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>End Date</mat-label>
        <input
          id="end-date"
          matInput
          [matDatepicker]="endPicker"
          [(ngModel)]="endDate"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="endPicker"
        ></mat-datepicker-toggle>
        <mat-datepicker #endPicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Redirect Type</mat-label>
        <mat-select [(ngModel)]="redirectType">
          @for (option of redirectTypeOptions; track option.value) {
            <mat-option [value]="option.value">{{ option.label }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <button mat-raised-button color="primary" (click)="fetchRedirectChecks()">
        <mat-icon>search</mat-icon>
        Fetch
      </button>
    </div>

    @if (isLoading) {
      <div class="loading-state">
        <mat-progress-spinner
          diameter="50"
          mode="indeterminate"
        ></mat-progress-spinner>
        <span>Loading redirect checks...</span>
      </div>
    }

    @if (!isLoading) {
      <table mat-table [dataSource]="dataSource" class="redirect-table">
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef>Date</th>
          <td mat-cell *matCellDef="let row">{{ formatDate(row.date) }}</td>
        </ng-container>

        <ng-container matColumnDef="source">
          <th mat-header-cell *matHeaderCellDef>Source</th>
          <td mat-cell *matCellDef="let row">{{ row.source }}</td>
        </ng-container>

        <ng-container matColumnDef="expectedDestination">
          <th mat-header-cell *matHeaderCellDef>Expected Destination</th>
          <td mat-cell *matCellDef="let row">{{ row.expectedDestination }}</td>
        </ng-container>

        <ng-container matColumnDef="actualDestination">
          <th mat-header-cell *matHeaderCellDef>Actual Destination</th>
          <td mat-cell *matCellDef="let row">{{ row.actualDestination }}</td>
        </ng-container>

        <ng-container matColumnDef="passed">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let row">
            @if (row.passed) {
              <mat-icon class="passed-icon">check_circle</mat-icon>
            } @else {
              <mat-icon class="failed-icon">cancel</mat-icon>
            }
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell no-data" [attr.colspan]="displayedColumns.length">
            No redirect check results found.
          </td>
        </tr>
      </table>
    }
  </mat-card-content>
</mat-card>
